module.exports = __webpack_public_path__ + "img/part-7-title.4749a0a0.png";